__turbopack_context__.v({
  "product": "Product-module-scss-module__3y8wPW__product",
});
